
const countLeadingKPIs = (initiative) => {
    if (!initiative || !initiative.KPI || !Array.isArray(initiative.KPI)) {
      return 0;
    }
  
    let valueLinkedCount = 0;
    initiative.KPI.forEach((kpi) => {
      if (kpi && kpi.TypeOfKPI === 'Leading') {
        valueLinkedCount++;
      }
    });
  
    return valueLinkedCount;
  };
  
  export default countLeadingKPIs;